/**
 * Normalize also_knownas / aka from tune metadata for display and search.
 */

function parseAlternateTitlesRaw(raw) {
  if (raw == null || raw === '') return [];
  if (Array.isArray(raw)) {
    return raw.map((x) => String(x).trim()).filter(Boolean);
  }
  if (typeof raw === 'string') {
    const s = raw.trim();
    if (!s) return [];
    if (s.startsWith('[')) {
      try {
        const arr = JSON.parse(s);
        if (Array.isArray(arr)) {
          return arr.map((x) => String(x).trim()).filter(Boolean);
        }
      } catch (_) {
        /* fall through */
      }
    }
    return s.split(/\s*\/\s*/).map((x) => x.trim()).filter(Boolean);
  }
  const one = String(raw).trim();
  return one ? [one] : [];
}

/** Comma-separated display string for the Tune Info grid. */
export function formatAlternateTitles(meta) {
  if (!meta || typeof meta !== 'object') return '';
  const titles = [
    ...parseAlternateTitlesRaw(meta.also_knownas),
    ...parseAlternateTitlesRaw(meta.aka),
  ];
  const seen = new Set();
  const unique = [];
  for (const t of titles) {
    const key = t.toLowerCase();
    if (!seen.has(key)) {
      seen.add(key);
      unique.push(t);
    }
  }
  return unique.join(' / ');
}

/** Expanded text for search haystacks (individual alias tokens). */
export function alternateTitlesSearchText(meta) {
  if (!meta || typeof meta !== 'object') return '';
  const titles = [
    ...parseAlternateTitlesRaw(meta.also_knownas),
    ...parseAlternateTitlesRaw(meta.aka),
  ];
  return titles.join(' ');
}
